import { useState } from "react";
import { Shield, ChevronDown, ChevronUp } from "lucide-react";

const AREA_NAMES = {
  liquidity: "Liquidez",
  profitability: "Rentabilidad",
  concentration: "Concentración",
  delinquency: "Morosidad",
  growth: "Crecimiento",
};

function scoreColor(score) {
  if (score <= 25) return "text-emerald-600";
  if (score <= 50) return "text-amber-500";
  if (score <= 75) return "text-orange-500";
  return "text-red-600";
}

function scoreBgColor(score) {
  if (score <= 25) return "bg-emerald-500";
  if (score <= 50) return "bg-amber-500";
  if (score <= 75) return "bg-orange-500";
  return "bg-red-500";
}

function scoreBgLight(score) {
  if (score <= 25) return "bg-emerald-100";
  if (score <= 50) return "bg-amber-100";
  if (score <= 75) return "bg-orange-100";
  return "bg-red-100";
}

export default function RiskGauge({ data }) {
  const [expanded, setExpanded] = useState(false);

  if (!data) return null;

  const { global_score, label, areas } = data;

  return (
    <div className="bg-white border border-slate-200 rounded-lg p-4">
      <div
        className="flex items-center justify-between cursor-pointer"
        onClick={() => setExpanded(!expanded)}
      >
        <div className="flex items-center gap-3">
          <div className={`flex items-center justify-center w-14 h-14 rounded-full ${scoreBgLight(global_score)}`}>
            <span className={`text-xl font-bold ${scoreColor(global_score)}`}>
              {global_score}
            </span>
          </div>
          <div>
            <div className="flex items-center gap-2">
              <Shield className={`w-4 h-4 ${scoreColor(global_score)}`} />
              <span className="text-sm font-semibold text-slate-900">Risk Score</span>
            </div>
            <p className={`text-sm font-medium ${scoreColor(global_score)}`}>{label}</p>
          </div>
        </div>
        {expanded ? (
          <ChevronUp className="w-4 h-4 text-slate-400" />
        ) : (
          <ChevronDown className="w-4 h-4 text-slate-400" />
        )}
      </div>

      {expanded && areas && (
        <div className="mt-4 space-y-2.5 pt-3 border-t border-slate-100">
          {Object.entries(areas).map(([key, area]) => (
            <div key={key} className="flex items-center gap-3">
              <span className="text-xs text-slate-500 w-24 shrink-0">
                {AREA_NAMES[key] || key}
              </span>
              <div className="flex-1 h-2 rounded-full bg-slate-100 overflow-hidden">
                <div
                  className={`h-full rounded-full transition-all ${scoreBgColor(area.score)}`}
                  style={{ width: `${area.score}%` }}
                />
              </div>
              <span className={`text-xs font-mono w-8 text-right ${scoreColor(area.score)}`}>
                {area.score}
              </span>
            </div>
          ))}
          <div className="pt-2">
            {Object.entries(areas).map(([key, area]) => (
              <p key={key} className="text-xs text-slate-500 leading-relaxed">
                <span className="font-medium text-slate-700">{AREA_NAMES[key]}:</span> {area.label}
              </p>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
